import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom AppTheme for this app
const AppTheme = createMuiTheme({
  palette: {
    common: {
      rage1: '#da2f47',
      rage2: '#292f33',
    },
    primary: {
      main: '#002b7f',
    },
    secondary: {
      main: '#fcd116',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#DFDCDA',
    },
  },
});

export default AppTheme;